import { render } from "./EventCollection.vue?vue&type=template&id=3ef39b9a"
import script from "./EventCollection.vue?vue&type=script&lang=js"
export * from "./EventCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__